// Order general
export const selectOrderState = state => state.order;
export const selectOrderLoading = state => state.order.loading;
export const selectOrderError = state => state.order.error;

// Orders
export const selectAllOrders = state => state.order.orders;
